<div class="page">
  <div class="content">
    <div class="content-header">
      <div class="title-primary">{{'LoginPrimaryTitle' | cpLoginTranslate | async}}</div>
      <div class="title-secondary">{{'LoginSecondaryTitle' | cpLoginTranslate | async}}</div>
    </div>
    <form class="form-container" [formGroup]="formControls" autocomplete="off" action="" (keydown)="onKeyDown($event)">
      <div class="label-wrapper">
        <label>{{'UserName' | cpLoginTranslate | async}}:</label>
      </div>
      <div class="input-wrapper">
        <input autofocus type="text" [(ngModel)]="userName" formControlName="userName" autocomplete="off" autocorrect="off" autocapitalize="off"
               [ngClass]="isUserNameFilled === 'invalid' ? 'input-invalid': ''"/>
        <label [ngStyle]="{'visibility':isUserNameFilled === 'invalid' ? 'visible' : 'hidden'}" class="text-invalid">
          {{'FillUserName' | cpLoginTranslate | async}}
        </label>
      </div>
      <div class="label-wrapper">
        <label>{{'Password' | cpLoginTranslate | async}}:</label>
      </div>
      <div class="input-wrapper">
        <input #Password [type]="!passwordVisible ? 'password' : 'text'" [(ngModel)]="password" formControlName="password" autocomplete="off" autocorrect="off" autocapitalize="off"
               [ngClass]="isPasswordFilled === 'invalid' ? 'input-invalid': ''"/>
        <span class="field-icon-wrapper">
          <i class="field-icon" [ngClass]="passwordVisible ? 'pp-icon-hide': 'pp-icon-show'" [attr.aria-hidden]="true" (click) = "togglePasswordVisibility()"></i>
        </span>
        <label [ngStyle]="{'visibility':isPasswordFilled === 'invalid' ? 'visible' : 'hidden'}" class="text-invalid">
          {{'FillPassword' | cpLoginTranslate | async}}
        </label>
      </div>
      <cp-button-widget-custom class="login-button primary-button call-to-action" captionToTranslate="LogInNow.Login.PP"
                               [disabled]="loginInProgress" (onClick)="login()"></cp-button-widget-custom>
      <div class="forgot-password-wrapper">
        <label class="forgot-password-link" (click)="!loginInProgress && doForgotPassword()">{{'ForgotPassword' | cpLoginTranslate | async}}</label>
      </div>
      <div *ngIf="!errorText1" [ngStyle]="{'visibility':loginInProgress ? 'visible' : 'hidden'}" class="progress-spinner">
        <div class="loading-image"></div>
      </div>
      <app-information-box
                 [text1]="errorText1"
                 [text1Args]="errorText1Args"
                 [text2]="errorText2"
                 [text3]="errorText3"
                 [actionTextIndex]="errorActionTextIndex"
                 [icon]="'pp-icon-error'"
                 [contactInfo]="contactInfoData"
                 (onAction)="errorAction()">
      </app-information-box>
      <div class="dont-have-account-wrapper">
        <label>{{'DontHaveAccount' | cpLoginTranslate | async}}</label>
      </div>
      <cp-button-widget-custom *ngIf="allowCreateAccount" class="secondary-button call-to-action" captionToTranslate="CreateAccount.Login.PP"
                               [disabled]="loginInProgress" (onClick)="newAccount()"></cp-button-widget-custom>
    </form>

    <ng-template #changePasswordTitle>
      <div class="popup-title-container contact-us">
        <div class="popup-title-text">{{'PasswordExpired' | cpLoginTranslate | async}}</div>
        <i class="pp-icon-close popup-close" (click)="popupWindowService.closeLatestPopup()"></i>
      </div>
    </ng-template>
  </div>

  <ng-template #contactUsTitle>
    <div class="popup-title-container contact-us">
      <div class="popup-title-text">{{'ContactUs' | cpTitleTranslate | async}}</div>
      <i class="pp-icon-close popup-close" (click)="popupWindowService.closeLatestPopup()"></i>
    </div>
  </ng-template>

  <ng-template #aboutTitle>
    <div class="popup-title-container about">
      <div class="popup-title-text">{{'About' | cpTitleTranslate | async}}</div>
      <i class="pp-icon-close popup-close" (click)="popupWindowService.closeLatestPopup()"></i>
    </div>
  </ng-template>

  <ng-template #termsTitle>
    <div class="popup-title-container terms">
      <div class="popup-title-text">{{'Terms' | cpTitleTranslate | async}}</div>
      <i class="pp-icon-close popup-close" (click)="popupWindowService.closeLatestPopup()"></i>
    </div>
  </ng-template>

  <div class="about-terms-wrapper">
    <span (click)="showAboutPage()">{{'About' | cpActionTranslate | async}}</span>
    |
    <span (click)="showTermsPage()">{{'Terms' | cpActionTranslate | async}}</span>
  </div>

  <div class="footer">
    <div><span (click)="showContactUsPage()">{{'ContactUs' | cpActionTranslate | async}}</span> {{'IfYouNeedHelp' | cpLabelTranslate | async}}</div>
  </div>
</div>
